import React, { Fragment, useState, createRef } from 'react';
import { useScreenshot } from 'use-react-screenshot'
import { useDispatch, useSelector } from "react-redux";

import EditIcon from '@mui/icons-material/Edit';
import {
    IconButton, 
    Link, 
    Checkbox,
    Button,
    Box,
    Divider,
    Grid,
    Typography,
    Dialog,
    DialogContent,
    DialogActions
} from '@mui/material'

import { submitFormDataAction  } from 'redux/actions/getFormActions';

const Form3 = (props) => {
    const {handleBack, handleNext } = props;
    const ref = createRef(null);
    const dispatch = useDispatch();
    const formData = useSelector(state => state.formData.data);
   
    const [image, takeScreenshot] = useScreenshot();
    const [termCheck, setTermCheck] = useState(false);

    const [open, setOpen] = useState(false);

    const handleSubmit = () => {
        takeScreenshot(ref.current);
        setOpen(true);
    }
    const handleOk = () => {
        dispatch(submitFormDataAction({
            ...formData,
            screenshot: image
        }))
        handleNext()
    }

  return (
    <Fragment>
        <Box ref={ref} sx={{p:2}}>
            <Grid container justifyContent="space-between"  >
                <Grid item md={12} xs={12}>
                    <Grid container justifyContent='space-around' sx={{ mt:2 }}>
                        <Grid item xs={5} sx={{mb:1}} >
                            <Typography variant="subtitle1" color="primary">First Name</Typography>
                            <Typography variant="body1">{formData.firstName}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">Last Name</Typography>
                            <Typography variant="body1">{formData.lastName}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">Organisation Name</Typography>
                            <Typography variant="body1">{formData.orgName}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">Email</Typography>
                            <Typography variant="body1">{formData.email}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">Phone Number</Typography>
                            <Typography variant="body1">{formData.phone}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">Number of Buildings</Typography>
                            <Typography variant="body1">{formData.buildingNumber}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">Number of Units</Typography>
                            <Typography variant="body1">{formData.unitsNumber}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}></Grid>
                    </Grid>
                </Grid>
                <Grid item md={12} xs={12}>
                    <Grid container justifyContent='space-around' sx={{ mt:2 }}>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">Address1</Typography>
                            <Typography variant="body1">{formData.street1}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">Address2</Typography>
                            <Typography variant="body1">{formData.street2}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">City</Typography>
                            <Typography variant="body1">{formData.city}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}>
                            <Typography variant="subtitle1" color="primary">Postal/ZipCode</Typography>
                            <Typography variant="body1">{formData.zipCode}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}} >
                            <Typography variant="subtitle1" color="primary">Country</Typography>
                            <Typography variant="body1">{formData.country}</Typography>
                        </Grid>
                        <Grid item xs={5} sx={{mb:1}}></Grid>
                    </Grid>
                </Grid>
            </Grid> 
            <Divider sx={{mt:1}}>
                <Grid container justifyContent='center' wrap="nowrap" alignItems="flex-start">
                    <Checkbox onChange={(e) => setTermCheck(e.target.checked)} checked={termCheck} />
                    <Link href="https://leapguaranty.co.uk/terms-and-conditions/" target="_blank" color="primary" sx={{mt:1}}>
                        <Typography color="primary" variant="subtitle1" align="center">     
                        Agree with Terms & Condition
                        </Typography>
                    </Link>
                </Grid>
            </Divider>
        </Box>
        <Box sx={{ display: 'flex', justifyContent: 'center', flexDirection: 'row', py: 2, mt:2 }}>
            <Button
                onClick={handleBack}
                sx={{ mr: 1 }}
                variant="contained"
            >
                <Typography variant='body1' >Back</Typography>
            </Button>

            <Button   
                onClick={() => handleSubmit()} 
                variant="contained" 
                disabled={!termCheck}
            >
                <Typography variant='body1' >Submit</Typography>
            </Button>
        </Box>
        <Dialog
          open={open} 
        >
        <DialogContent sx={{p:2, pb:0}}>
            <Grid container wrap="nowrap" alignItems="start">
                <Typography color="primary" variant="body1" sx={{p:1}}>     
                Is the information you entered correct?
                </Typography>
          
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button variant='contained' color="error" onClick={() => setOpen(false)}>
                <Typography> Cancel </Typography>
            </Button>
            <Button onClick={() => handleOk()} autoFocus variant='contained' color='primary'>
                <Typography> Ok </Typography>
            </Button>
        </DialogActions>
      </Dialog>
    </Fragment>
  );
}

export default Form3;
